/* ND-PL · pastille « il reste N jours » des encadrés de relance (maquettes de Mélanie, septembre 2026).
   Même calcul que la maquette : jours arrondis au-dessus jusqu'à l'échéance, pastille masquée une
   fois l'échéance passée. L'échéance vient de l'attribut data-nd-reste (date ISO avec fuseau), donc
   aucun chiffre n'est écrit en dur : la page reste juste le 29 au soir comme le 25. Chargé par chaque
   section nd-pl-bloc qui contient une pastille ; le garde window.ndPlReste évite les doublons. */
(function () {
  if (window.ndPlReste) return;
  window.ndPlReste = true;

  function maj() {
    var restes = document.querySelectorAll('[data-nd-reste]');
    for (var i = 0; i < restes.length; i++) {
      var el = restes[i];
      var cible = Date.parse(el.getAttribute('data-nd-reste'));
      if (isNaN(cible)) continue;
      var r = cible - Date.now();
      if (r <= 0) {
        el.hidden = true;
        continue;
      }
      var j = Math.ceil(r / 86400000);
      el.textContent = j === 1 ? 'il reste 1 jour' : 'il reste ' + j + ' jours';
      el.hidden = false;
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maj);
  else maj();
  setInterval(maj, 60000);
})();
